import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMessagesUI } from '../../contexts/MessagesUIContext';

const MessagesPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { openMessages } = useMessagesUI();

  useEffect(() => {
    openMessages({
      conversationId: location.state?.conversationId,
      compose: location.state?.compose,
    });
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/home', { replace: true });
    }
  }, []);

  return null;
};

export default MessagesPage;
